/**
 * What the Apps launcher shows, from the organization's app entries: the apps
 * in use, then every other app the organization can add. Pure, so the split
 * is pinned by tests.
 *
 * @module components/apps/appsLauncher
 */
import type { AppEntry } from "./appRegistry";

export interface LauncherSections {
  readonly inUse: ReadonlyArray<AppEntry>;
  readonly available: ReadonlyArray<AppEntry>;
}

/** In use: Amoreg's own apps and everything connected. Available: everything else, in entry order. */
export function launcherSections(entries: ReadonlyArray<AppEntry>): LauncherSections {
  const isInUse = (entry: AppEntry) =>
    entry.kind === "first-party" || entry.availability === "connected";
  return { inUse: entries.filter(isInUse), available: entries.filter((entry) => !isInUse(entry)) };
}

/** The line under a tile's name. */
export function launcherTileCaption(entry: AppEntry): string {
  switch (entry.kind) {
    case "first-party":
      return "Amoreg app";
    case "custom":
      return entry.availability === "connected" ? "Custom MCP · on" : "Custom MCP · off";
    case "integration":
      return entry.availability === "connected" ? "Connected" : "Not connected";
    case "coming-soon":
      return "Coming soon";
  }
}
